// Global App object for legacy JS code.
// Please do not use this for new development.
window.CortanaApp = window.CortanaApp || {};

const AppHandler = {
  get: function get(_target, prop, _receiver) {
    if (process.env.NODE_ENV === "development") {
      console.warn(
        `Cortana: using the App global object is deprecated. Requested property: ${prop}`
      );
    }
    return window.CortanaApp[prop];
  },

  set: function set(_obj, prop, value) {
    if (process.env.NODE_ENV === "development") {
      console.warn(`Cortana: using the App global object is deprecated. Updated property: ${prop}`);
    }
    window.CortanaApp[prop] = value;
    return window.CortanaApp;
  },
};

export default App = new Proxy({}, AppHandler);
